import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import joblistReducer from './slices/joblist';
import jobleveltempReducer from './slices/jobleveltemp';
import applicantstagesReducer from './slices/applicantstages';
import employeeareaReducer from './slices/employeearea';
import employeeofficeReducer from './slices/employeeoffice';
import employeepositionReducer from './slices/employeeposition';
import myprofileReducer from './slices/myprofile';
import genderReducer from './slices/gender';
import religionReducer from './slices/religion';
import applicantDataReducer from './slices/applicantdata';
import educationReducer from './slices/education';
import experienceReducer from './slices/experience';
import applicantfileReducer from './slices/applicantfile';
import educationtypeReducer from './slices/educationtypes';
import educationlevelReducer from './slices/educationlevels';
import pipelineReducer from './slices/pipeline';
import myjobReducer from './slices/myjob';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

export const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};
export const joblistPersistConfig = {
  key: 'joblist',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const employeeofficePersistConfig = {
  key: 'employeeoffice',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const employeepositionPersistConfig = {
  key: 'employeeposition',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const jobleveltempPersistConfig = {
  key: 'jobleveltemp',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const applicantstagesPersistConfig = {
  key: 'applicantstages',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const myprofilePersistConfig = {
  key: 'myprofile',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const religionPersistConfig = {
  key: 'religion',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const genderPersistConfig = {
  key: 'gender',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const applicantdataPersistConfig = {
  key: 'applicantdata',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const educationPersistConfig = {
  key: 'education',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const experiencePersistConfig = {
  key: 'experience',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const applicantfilePersistConfig = {
  key: 'applicantfile',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const educationtypePersistConfig = {
  key: 'educationtype',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const educationlevelPersistConfig = {
  key: 'educationlevel',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const pipelinePersistConfig = {
  key: 'pipeline',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
export const myjobPersistConfig = {
  key: 'myjob',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  joblistReducer: persistReducer(joblistPersistConfig, joblistReducer),
  jobleveltempReducer: persistReducer(jobleveltempPersistConfig, jobleveltempReducer),
  applicantstagesReducer: persistReducer(applicantstagesPersistConfig, applicantstagesReducer),
  employeepositionReducer: persistReducer(employeepositionPersistConfig, employeepositionReducer),
  employeeoffice: persistReducer(employeeofficePersistConfig, employeeofficeReducer),
  myprofileReducer: persistReducer(myprofilePersistConfig, myprofileReducer),
  gender: persistReducer(genderPersistConfig, genderReducer),
  religionReducer: persistReducer(religionPersistConfig, religionReducer),
  applicantDataReducer: persistReducer(applicantdataPersistConfig, applicantDataReducer),
  educationReducer: persistReducer(educationPersistConfig, educationReducer),
  experienceReducer: persistReducer(experiencePersistConfig, experienceReducer),
  applicantfileReducer: persistReducer(applicantfilePersistConfig, applicantfileReducer),
  educationtype: persistReducer(educationtypePersistConfig, educationtypeReducer),
  educationlevelReducer: persistReducer(educationlevelPersistConfig, educationlevelReducer),  
  pipelineReducer: persistReducer(pipelinePersistConfig, pipelineReducer),  
  myjobReducer: persistReducer(myjobPersistConfig, myjobReducer),  
});

export default rootReducer;
